<h1 mat-dialog-title>
  {{ isVendedor ? 'Detalles del Producto' : (data.isEdit ? 'Editar Producto' : 'Nuevo Producto') }}
</h1>

<div mat-dialog-content>
  <form [formGroup]="mainForm" (ngSubmit)="handleFormSubmit($event)">
    <mat-tab-group animationDuration="0ms">
      <!-- Pestaña de Información Básica -->
      <mat-tab label="Información Básica">
        <div class="tab-content">
          <app-form-component 
            [fieldsConfig]="formSections['basic']"
            [formGroup]="mainForm"
            [formLayout]="'vertical'"
            [showBotons]="false"
            [canEdit]="!isVendedor">
          </app-form-component>
        </div>
      </mat-tab>

      <!-- Pestaña de Detalles -->
      <mat-tab label="Detalles">
        <div class="tab-content">
          <app-form-component 
            [fieldsConfig]="formSections['details']"
            [formGroup]="mainForm"
            [formLayout]="'vertical'"
            [canEdit]="!isVendedor">
          </app-form-component>
        </div>
      </mat-tab>

      <!-- Pestaña de Inventario -->
      <mat-tab label="Inventario">
        <div class="tab-content">
          <app-form-component 
            [fieldsConfig]="formSections['inventory']"
            [formGroup]="mainForm"
            [formLayout]="'vertical'"
            [canEdit]="!isVendedor">
          </app-form-component>
        </div>
      </mat-tab>
        <!-- Pestaña de Extra -->
        <mat-tab label="Extra">
          <div class="tab-content">
            <app-form-component 
              [fieldsConfig]="formSections['extraFields']"
              [formGroup]="mainForm"
              [formLayout]="'vertical'"
              [showBotons]="false"
              [canEdit]="!isVendedor">
            </app-form-component>
          </div>
        </mat-tab>
    </mat-tab-group>

    <div mat-dialog-actions align="end">
      <button mat-button type="button" (click)="onCancel()">{{ isVendedor ? 'Cerrar' : 'Cancelar' }}</button>
      <button *ngIf="!isVendedor" 
              mat-raised-button color="primary" type="submit">
        {{ data.isEdit ? 'Actualizar' : 'Guardar' }}
      </button>
    </div>
  </form>
</div>